import React from 'react';
import { Badge } from 'components/ui/badge';
import { Truck, User } from 'lucide-react';
import { format, isValid, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';

// Props for FleetTourHeader
export interface FleetTourHeaderProps {
  selectedTour: any;
  selectedVehicle: any;
  currentStopForSelectedTour: any;
}

// Header component for displaying selected tour information
const FleetTourHeader: React.FC<FleetTourHeaderProps> = ({
  selectedTour,
  selectedVehicle,
  currentStopForSelectedTour,
}) => {
  if (!selectedTour) return null;
  return (
    <div className="mb-6 pb-4 border-b border-gray-200">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-2">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            {`Tournée ${selectedTour.id} du ${
              isValid(parseISO(selectedTour.date))
                ? format(parseISO(selectedTour.date), 'd MMMM yyyy', {
                    locale: fr,
                  })
                : 'Date invalide'
            }`}
          </h2>
          <p className="text-sm text-gray-500">
            Véhicule: {selectedVehicle?.name || 'N/D'} (Plaque:{' '}
            {selectedVehicle?.licensePlate || 'N/D'})
          </p>
        </div>
        <div className="flex space-x-2 mt-2 sm:mt-0">
          <Badge variant="secondary" className="text-sm">
            <User className="mr-1.5 h-4 w-4" />
            {selectedTour.drivers[0]?.name || 'N/D'}
          </Badge>
          <Badge
            variant={selectedTour.delivered ? 'secondary' : 'default'}
            className="text-sm"
          >
            <Truck className="mr-1.5 h-4 w-4" />
            {selectedTour.delivered
              ? 'Terminée'
              : currentStopForSelectedTour?.status === 'DELAYED'
              ? 'En retard'
              : 'En cours'}
          </Badge>
        </div>
      </div>
    </div>
  );
};

export default FleetTourHeader;
